import { all } from 'redux-saga/effects';

import { env } from '@/env';
import { saga as auth } from '@/modules/auth/services/sagas';
import { saga as backendVersion } from '@/modules/backend-version/services/saga';
import { saga as changelog } from '@/modules/changelog';
import { saga as groups } from '@/modules/groups';
import { saga as importExport } from '@/modules/import-export/services/sagas';
import { saga as localizationsSaga } from '@/modules/localizations';
import { saga as messages } from '@/modules/messages';
import { saga as network } from '@/modules/network';
import { saga as reviewPrizepool } from '@/modules/review-prizepool';
import { saga as secrets } from '@/modules/secrets';
import { saga as tags } from '@/modules/secrets/modules/tags';
import { saga as securityAudit } from '@/modules/security-audit';
import { saga as settings } from '@/modules/settings/services/sagas';
import { saga as userFeedback } from '@/modules/user-feedback';
import { saga as wakeUp } from '@/modules/wake-up';
import { saga as whitelist } from '@/modules/whitelist';

import { app } from './app';

export default function* rootSaga() {
    yield all(
        [
            auth(),
            localizationsSaga(),
            app(),
            messages(),
            secrets(),
            groups(),
            whitelist(),
            network(),
            importExport(),
            changelog(),
            settings(),
            securityAudit(),
            backendVersion(),
            tags(),
            reviewPrizepool(),
            !env.VITE_DEMO && !env.VITE_SAAS ? wakeUp() : undefined,
            !env.VITE_DEMO ? userFeedback() : undefined,
        ].filter(Boolean),
    );
}
